<style lang="scss">
  .booksContent {
    overflow: hidden;
    .books {
      position: relative;
      z-index: 2;
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      grid-gap: 50px;
    }
    .showMoreBtn {
      display: block;
      width: 100%;
      margin: 50px 0;
    }
    @media (min-width: 576px) {
      .books {
        grid-template-columns: repeat(2, 1fr);
      }
    }
    @media (min-width: 992px) {
      .books {
        grid-template-columns: repeat(4, 1fr);
      }
    }
  }
</style>
<template>
  <div class="booksContent">
    <FrontendNav></FrontendNav>
    <div class="container">
      <FrontendBooklistHeader
        :title="catName"
        :url="catUrl"
        :order="catOrder"
        :cats="categories"
        :activeCat="activeCat"
        v-on:cat-change="catChange"
        :key="fbhKey"
        :author="author"
        :price="price"
        v-on:authorChange="orderByAuthorChange"
        v-on:priceChange="orderByPriceChange"
      ></FrontendBooklistHeader>
      <ul class="books">
        <li v-for="book in books" :key="book.id">
          <FrontendBooklink
            :button="true"
            :book="book"
          ></FrontendBooklink>
        </li>
      </ul>
      <button v-if="isMoreBtn" @click="loadMore" class="btn btn-default showMoreBtn">Mutass többet</button>
    </div>
    <FrontendFooter></FrontendFooter>
  </div>
</template>

<script>
import FrontendNav from '../partials/nav'
import FrontendFooter from '../partials/footer'
import FrontendBooklistHeader from '../partials/booklistheader'
import FrontendBooklink from '../partials/booklink'

export default {
  name: 'FrontendBooks',
  components: {
    FrontendNav,
    FrontendFooter,
    FrontendBooklink,
    FrontendBooklistHeader
  },
  computed: {
    url: function () {
      return process.env.API_URL + '/' + process.env.API_ENDPOINT
    },
    categoryId: function () {
      for (let item in this.categories) {
        if (this.categories[item].url === '/konyvek/' + this.$route.params.categorySlug) {
          return this.categories[item].id
        }
      }
      return null
    },
    categoryName: function () {
      for (let item in this.categories) {
        if (this.categories[item].url === '/konyvek/' + this.$route.params.categorySlug) {
          return this.categories[item].name
        }
      }
      return null
    }
  },
  created: function () {
    let self = this
    self.$http
      .get(self.url + `/categories`, {
        'headers': {
          'language': self.$store.state.loading.language
        }
      }).then(res => {
        self.categories = res.data.data
        self.catChange()
      }).catch(res => {
      })
  },
  methods: {
    orderByAuthorChange: function (val) {
      for (let it in this.order_by) {
        if (this.order_by[it] === 'author') {
          this.order_by.splice(it, 1)
          this.order.splice(it, 1)
        }
      }

      if (val != null) {
        this.order_by.push('author')
        this.order.push(val)
      }

      if (this.categoryId !== null) {
        this.getBooks(this.url + `/books/` + this.limit + `/` + this.offset + `/` + this.categoryId)
      } else {
        this.getBooks(this.url + `/books/` + this.limit + `/` + this.offset)
      }
    },
    orderByPriceChange: function (val) {
      for (let it in this.order_by) {
        if (this.order_by[it] === 'price') {
          this.order_by.splice(it, 1)
          this.order.splice(it, 1)
        }
      }

      if (val != null) {
        this.order_by.push('price')
        this.order.push(val)
      }

      if (this.categoryId !== null) {
        this.getBooks(this.url + `/books/` + this.limit + `/` + this.offset + `/` + this.categoryId)
      } else {
        this.getBooks(this.url + `/books/` + this.limit + `/` + this.offset)
      }
    },
    catChange: function () {
      if (this.categoryId) {
        this.catName = this.categoryName
        this.activeCat = '/konyvek/' + this.$route.params.categorySlug
        this.fbhKey += 1
        this.getBooks(this.url + `/books/` + this.limit + `/` + this.offset + `/` + this.categoryId)
      } else {
        this.catName = 'Összes'
        this.activeCat = '/konyvek/' + this.$route.params.categorySlug
        this.getBooks(this.url + `/books/` + this.limit + `/` + this.offset)
      }
    },
    loadMore: function () {
      this.offset += this.limit
      this.getBooks(this.url + `/books/` + this.limit + `/` + this.offset, true)
    },
    getBooks: function (_url, add = false) {
      if (this.order_by !== null) {
        _url += '?order_by=' + this.order_by + '&order=' + this.order
      }

      this.$http
        .get(_url, {
          'headers': {
            'language': this.$store.state.loading.language
          }
        }).then(res => {
          if (res.data.data.length < this.limit) {
            this.isMoreBtn = false
          } else {
            this.isMoreBtn = true
          }
          if (add) {
            for (let item in res.data.data) {
              this.books.push(res.data.data[item])
            }
          } else {
            this.books = res.data.data
          }
        }).catch(res => {
        })
    }
  },
  data: function () {
    return {
      catName: 'Összes',
      catUrl: '',
      activeCat: '/konyvek',
      catOrder: true,
      categories: [],
      books: [],
      fbhKey: 0,
      limit: 16,
      offset: 0,
      isMoreBtn: false,
      order_by: [],
      order: []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/frontend/books/books.vue